module.exports = __webpack_public_path__ + "img/1482571137.5c77977b.jpg";